import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import { LuDownload } from "react-icons/lu";
import "./InvestorPresentations.style.css";

const InvestorPresentations = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const L = i18next.language?.startsWith("tr") ? "tr" : "en";

  // Tek tablo, tek veri
  const presentations = [
    {
      name: {
        tr: "Yatırımcı Sunumu 2Ç 2025",
        en: "Investor Presentation Q2 2025",
      },
      href: {
        tr: "/static/docs/presentations/2025-q2-presentation-tr.pdf",
        en: "/static/docs/presentations/2025-q2-presentation-en.pdf",
      },
    },
  ];

  return (
    <div>
      <Meta title={t("investor-presentations")} description={t("investor-presentations")} lang={lang} />
      <Navbar />

      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("investor-presentations")}
              </h1>
            </div>
          </div>
        </div>

        {/* İçerik */}
        <div className="po-container">
          <InvestorSidebar />

          <main className="pol-content">
            <section className="pol-card">
              <ul className="pol-list">
                {presentations.map((p, i) => (
                  <li key={i} className="pol-row">
                    <span className="pol-title">{p.name[L] || p.name.en}</span>
                    <a
                      href={p.href[L] || p.href.en}
                      target="_blank"
                      rel="noreferrer"
                      className="pol-dl"
                      aria-label={(t("download") || "İndir") + ": " + (p.name[L] || p.name.en)}
                    >
                      <LuDownload size={18} />
                    </a>
                  </li>
                ))}
              </ul>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default InvestorPresentations;
